import React, { useState, useEffect } from "react";
import EditIcon from "@mui/icons-material/Edit";
import { toast } from "react-toastify";

// import JS files
import useFetch from "../../../../context/useFetch";
import MuiButton from "../../../shares/MuiButton";
import MuiTextField from "../../../shares/MuiTextField";
import TableIconModal from "../../../shares/TableIconModal";

// import Others files

const EditCity = (props) => {
  let windowWidth = window.screen.width;
  const [editedName, setEditedName] = useState();
  const [openModal, setOpenModal] = useState(false);

  useEffect(() => {
    setEditedName(props.selectedRow?.name);
  }, [props.selectedRow]);

  const EditCityApi = useFetch({
    method: "patch",
    url: `City_Service/${props.selectedRow?.id}`,

    trigger: false,
    data: { name: editedName },
    argFunc: (res) => {
      props.getCitiesApi.reFetch();
      // toast.success("شهر موردنظر با موفقیت ویرایش شد", {
      //   position: toast.POSITION.TOP_CENTER,
      // });
      setOpenModal(false);
    },
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });

  return (
    <>
      <TableIconModal
        width="w-2/5"
        icon={<EditIcon />}
        isOverflow={true}
        isNotBackdropClick={true}
        openModal={openModal}
        setOpenModal={setOpenModal}
      >
        <div>
          <div className="mt-4">
            <div className="mt-4">
              <MuiTextField
                onChange={(e) => setEditedName(e.target.value)}
                id="outlined-basic"
                label="نام"
                variant="outlined"
                size="small"
                value={editedName}
                autoFocus
              />
            </div>
            <div className="flex justify-end mt-4">
              <MuiButton
                onClick={EditCityApi.reFetch}
                variant="contained"
                color="success"
                text="ویرایش"
                disabled={EditCityApi.loading}
              />
            </div>
          </div>
        </div>
      </TableIconModal>
    </>
  );
};

export default EditCity;
